export default "__VITE_ASSET__BEuOgqDA__"